import React, { Component } from "react";
import PropTypes from "prop-types";
import { connectInfiniteHits } from "react-instantsearch-dom";
import { throttle } from "lodash";
import classNames from "classnames";

class Hits extends Component {
    state = {
        hovered: false,
        bannerActive: true
    };

    static propTypes = {
        hitComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
        brand: PropTypes.object,
        listType: PropTypes.string.isRequired,
        hits: PropTypes.arrayOf(PropTypes.object).isRequired,
        hasMore: PropTypes.bool.isRequired,
        refine: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.handleScroll = throttle(this.handleScroll.bind(this), 250);
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll() {
        const { hasMore, refine } = this.props;

        if (!hasMore) {
            return;
        }

        const { bottom } = this.ref.getBoundingClientRect();
        const { innerHeight } = window;

        // When the bottom of the grid is half a window height away from
        // appearing in the viewport
        if (bottom - innerHeight / 2 <= innerHeight) {
            refine();
        }
    }

    handleMouseOver = () => {
        this.setState({ hovered: true });
    };

    handleMouseOut = () => {
        this.setState({ hovered: false });
    };

    handleRef = ref => {
        this.ref = ref;
    };

    render() {
        const {
            hits,
            hitComponent: HitComponent,
            brand,
            listType
        } = this.props;
        const { hovered } = this.state;

        return (
            <div
                className={classNames("hits", {
                    "hits--hovered": hovered,
                    "hits--no-banner": !brand
                })}
                ref={this.handleRef}
            >
                {brand && (
                    <div className="hits__banner">
                        <div
                            className="hits__banner-logo"
                            style={{
                                backgroundImage: `url('${brand.image}')`
                            }}
                        />
                        <div
                            className="hits__banner-text"
                            dangerouslySetInnerHTML={{
                                __html: brand.description
                            }}
                        />
                    </div>
                )}

                <div className="hits__wrap">
                    {hits.map((hit, index) => {
                         return hit.family && hit.family.brand ? (
                                <div
                                key={hit.objectID}
                                className="hits__hit"
                                onMouseOver={this.handleMouseOver}
                                onMouseOut={this.handleMouseOut}
                            >
                                <div className="hits__hit-inside">
                                    <HitComponent
                                        hit={hit}
                                        position={index}
                                        listType={listType}
                                    />
                                </div>
                            </div>
                         ) : null
                    })}
                </div>
            </div>
        );
    }
}

export default connectInfiniteHits(Hits);



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/Hits.js